import { supabase } from '../../core/config/supabase';
import { ParticipantEntity } from '../entities';

export class ParticipantDataSource {
  async create(participant: Omit<ParticipantEntity, 'id' | 'created_at'>): Promise<ParticipantEntity> {
    const { data, error } = await supabase
      .from('participants')
      .insert(participant)
      .select()
      .single();

    if (error) throw new Error(error.message);
    if (!data) throw new Error('No data returned from insert');

    return data as ParticipantEntity;
  }

  async getById(id: string): Promise<ParticipantEntity | null> {
    const { data, error } = await supabase
      .from('participants')
      .select('*')
      .eq('id', id)
      .single();

    if (error) {
      if (error.code === 'PGRST116') return null; // Not found
      throw new Error(error.message);
    }

    return data as ParticipantEntity;
  }

  async getByTournamentId(tournamentId: string): Promise<ParticipantEntity[]> {
    const { data, error } = await supabase
      .from('participants')
      .select('*')
      .eq('tournament_id', tournamentId)
      .order('seed', { ascending: true, nullsFirst: false });

    if (error) throw new Error(error.message);

    return (data as ParticipantEntity[]) || [];
  }

  async getByUserId(userId: string): Promise<ParticipantEntity[]> {
    const { data, error } = await supabase
      .from('participants')
      .select('*')
      .eq('user_id', userId)
      .order('created_at', { ascending: false });

    if (error) throw new Error(error.message);

    return (data as ParticipantEntity[]) || [];
  }

  async update(id: string, participant: Partial<ParticipantEntity>): Promise<ParticipantEntity> {
    const { data, error } = await supabase
      .from('participants')
      .update(participant)
      .eq('id', id)
      .select()
      .single();

    if (error) throw new Error(error.message);
    if (!data) throw new Error('No data returned from update');

    return data as ParticipantEntity;
  }

  async delete(id: string): Promise<void> {
    const { error } = await supabase
      .from('participants')
      .delete()
      .eq('id', id);

    if (error) throw new Error(error.message);
  }
}
